import { Component, type ReactNode } from 'react'

import { estErreurChargementModule, repriseChargement } from '@/lib/repriseChargement'

type Props = { children: ReactNode }
type State = { failed: boolean }

/**
 * Dernière frontière : la coquille et l'écran de connexion sont chargés à la demande, hors de toute frontière de
 * route. Sans elle, React démonte la racine et la page reste blanche. L'écran rendu est celui du secours d'amorçage
 * (`index.html`) : il tient le budget des relances et ne dépend pas de l'arbre qui vient de tomber.
 */
export class RacineErrorBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(erreur: unknown): void {
    if (estErreurChargementModule(erreur)) repriseChargement()?.echecChargement()
    else repriseChargement()?.echecRendu()
  }

  render(): ReactNode {
    return this.state.failed ? null : this.props.children
  }
}
